import * as React from "react";

const IconClose = (props) => (
  <svg
    width={32}
    height={32}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={16} cy={16} r={15.5} stroke="#A9AFD9" />
    <path d="m11 11 10 10M21 11 11 21" stroke="#A9AFD9" strokeLinecap="round" />
  </svg>
);

export default IconClose;
